module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ahip43-0f7ee382cbf21b9abc5f8945cd0539ca.jpg";